module.exports = __webpack_public_path__ + "img/ch07_05_列车进站.f0fd550d.jpg";